import { filterDropDownList } from "./DropdownUtils";

export const includesValueNormalized = (inputValue, expected) => {
  if (inputValue === null || inputValue === undefined) return false;

  if (Array.isArray(inputValue)) {
    return inputValue.map(String).includes(String(expected));
  }

  const asString = String(inputValue);
  const parts = asString.split(",").map(p => p.trim()).filter(Boolean);
  return parts.includes(String(expected));
};

export const handleConditionBaseFields = (value, formData, fieldId, triggerValue) => {
  const updatedFormData = { ...formData };
  const triggers = Array.isArray(triggerValue) ? triggerValue : [triggerValue];
  const isVisible = triggers.some(t => includesValueNormalized(value, t));

  updatedFormData.formFields = updatedFormData.formFields.map((field) => {
    if (field.id === fieldId) {
      return {
        ...field,
        validation: isVisible ? [{ type: "require" }] : [],
        style: {
          ...field.style,
          containerCss: isVisible ? "col-md-5 mb-2" : "col-md-5 mb-2 d-none"
        }
      };
    }
    return field;
  });
  updatedFormData.initialState = {
    ...updatedFormData.initialState,
    [fieldId]: isVisible ? updatedFormData.initialState[fieldId] : null
  };

  return updatedFormData;
};


//  manage other spwcify field based on productsandServicesOfferedbyOrganisation value

export const toggleFieldVisibilityWithLabel = (formData, { dataFieldValue, triggerMap, targetFieldId }) => {
  const selectedValues = Array.isArray(dataFieldValue) ? dataFieldValue: [dataFieldValue];
  const matchedKey = selectedValues.find((val) => triggerMap[val]);
  const matchedTrigger = matchedKey ? triggerMap[matchedKey] : "";
  const shouldShow = Boolean(matchedKey);

  return {
    ...formData,
    formFields: formData.formFields.map((field) => {
      if (field.id !== targetFieldId) return field;

      return {
        ...field,
        lable: shouldShow ? matchedTrigger : field.lable,
        Field_Name: shouldShow ? matchedTrigger : field.Field_Name,
        fieldSetting: { ...field.fieldSetting,isDisable: !shouldShow,},
        validation: shouldShow ? [{ type: "require" }] : [],
        style: {...field.style,containerCss: "col-md-5 mb-3", },
      };
    }),
    initialState: {
      ...formData.initialState,
      [targetFieldId]: shouldShow
        ? formData.initialState[targetFieldId]
        : null,
    },
  };
};


export const applyProductServiceInitialState = ({ formData, dropdownData, orgCategory, productsAndServices, isRenewal }) => {
  if (!orgCategory) return formData;
  const serviceOptions = dropdownData ? filterDropDownList(`org${orgCategory}`, dropdownData): [];

  const triggerMap = {
    12: "Others; Please specify",
    18: "Others; Please specify",
    38: "Others; Please specify",
  };

  const selectedValues = Array.isArray(productsAndServices) ? productsAndServices: [productsAndServices];
  const matchedKey = selectedValues.find((val) => triggerMap[val]);
  const labelText = matchedKey ? triggerMap[matchedKey] : "";
  const shouldShow = Boolean(matchedKey);

  return {
    ...formData,
    formFields: formData?.formFields.map((field) => {
      if (field.id === "productsandServicesOfferedbyOrganisation") {
        return {...field,fieldSetting: {...field.fieldSetting,options: serviceOptions,},};
      }

      if (field.id === "reasonforjoiningSGBCCorporateMembership") {
        return {
          ...field,
          lable: isRenewal
            ? "Reason for renewing SGBC Corporate Membership"
            : "Reason for joining SGBC Corporate Membership",
          Field_Name: isRenewal
            ? "Reason for renewing SGBC Corporate Membership"
            : "Reason for joining SGBC Corporate Membership",
        };
      }

      if (field.id === "otherproductsandServices") {
        return {
          ...field,
          lable: shouldShow ? labelText : field.lable,
          Field_Name: shouldShow ? labelText : field.Field_Name,
          validation: shouldShow ? [{ type: "require" }] : [],
          fieldSetting: {...field.fieldSetting,isDisable: !shouldShow,},
          style: {
            ...field.style,
            containerCss: "col-md-5 mb-3",
          },
        };
      }

      return field;
    }),
  };
};
